module.exports = __webpack_public_path__ + "img/0-31.58c2b5da.jpg";